module.exports = __webpack_public_path__ + "static/media/shield.b4fdee5a.png";